import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Settings Layout Route (Protected)
 *
 * Pathless layout wrapper for all /settings/* sub-routes.
 * Renders <Outlet /> so child routes (profile, email, address, etc.)
 * mount in place. The hub screen lives in settings.index.tsx.
 */
export const Route = createFileRoute('/_authenticated/settings')({
  component: () => <Outlet />,
});
